import PrivateRoute from 'utils/privateRoute';
import Dashboard from 'components/dashboard/dashboard';
import SessionLogout from 'utils/SessionLogout';

const DashboardRoutes = [
	{
		key: 'dash_admin',
		route: '/dashboard/administrative',
		component: (
			<PrivateRoute
				Component={Dashboard}
				restrictedRoles={[
					'Platform Support',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'dash_oper',
		route: '/dashboard/operational',
		component: (
			<PrivateRoute
				Component={Dashboard}
				restrictedRoles={[
					'Platform Support',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'dash_busi',
		route: '/dashboard/business',
		component: (
			<PrivateRoute
				Component={Dashboard}
				restrictedRoles={[
					'Platform Support',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'dash_job_perf',
		route: '/dashboard/jobPerformance',
		component: (
			<PrivateRoute
				Component={Dashboard}
				restrictedRoles={[
					'Platform Support',
					'Data Operations Admin',
					'Data Operations User',
					'D&AI Executive User',
					'Program Executive'
				]}
			/>
		)
	},
	{
		key: 'dash_logout',
		route: '/dashboard/sessionTimeOut',
		component: (
			<PrivateRoute
				Component={SessionLogout}
			/>
		)
	}
];

export default DashboardRoutes;
